<template>
  <div class="pop_box">
    <div class="mask"></div>
    <div class="pop_main">
      <div class="pop_cont">
        <h2 class="overflow_line2">{{ pop_data.title}}</h2>
        <p v-html="pop_data.content"></p>
      </div>
      <div class="pop_close" v-on:click="hidePop">
        <img src="../assets/images/close.png" alt>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    pop_data: {}
  },
  methods: {
    hidePop: function() {
      this.$emit("hidePop");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/global.less";
.pop_box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 99;
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.8;
    position: absolute;
    z-index: 999;
  }
  .pop_main {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .pop_cont {
      background: #ffffff;
      padding: 20px;
      width: 60%;
      @media screen and (max-width: 768px) {
        width: 80%;
      }
      height: 80%;
      z-index: 999;
      overflow: scroll;
      overflow: scroll;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 1px;
        background: @bordercolor;
      }
      opacity: 1;
      img {
        max-width: 150px;
        border-radius: 50%;
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
        margin-top: 20px;
        margin-bottom: 30px;
        @media screen and (max-width: 768px) {
          font-size: 18px;
          margin-bottom: 20px;
        }
      }
    }
    .pop_close {
      width: 100%;
      z-index: 999;
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>

